import type { ReactNode } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { ErrorBoundary } from '@/components/ErrorBoundary/ErrorBoundary';
import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute/ProtectedRoute';
import { MainLayout } from '@/layouts/MainLayout/MainLayout';
import { BookListPage } from '@/pages/Books/BookListPage';
import { BookFormPage } from '@/pages/Books/BookFormPage';
import { CollectionsPage } from '@/pages/Collections/CollectionsPage';
import { SeriesPage } from '@/pages/Collections/SeriesPage';
import { LoginPage } from '@/pages/Login/LoginPage';

export function App(): ReactNode {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <Outlet />
                  </MainLayout>
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<BookListPage />} />
              <Route path="/books" element={<Navigate to="/" replace />} />
              <Route path="/books/new" element={<BookFormPage />} />
              <Route path="/books/:id/edit" element={<BookFormPage />} />
              <Route path="/collections" element={<CollectionsPage />} />
              <Route path="/collections/:seriesId" element={<SeriesPage />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
